import $ from 'jquery';
import 'slick-carousel';

$('.blog-category-slider').each(function () {
  const sliderID = $(this).data('slider');

  const $blogCategorySlider = $(`.${sliderID}`);
  const $blogCurrentSlide = $(`.controls-current-${sliderID}`);



  $blogCategorySlider.slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
    arrows: true,
    nextArrow: $(`.controls-next-${sliderID}`),
    prevArrow: $(`.controls-prev-${sliderID}`),
    dots: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '8%',
        },
      },
    ],
  });

  $blogCategorySlider.on('init reInit afterChange', function (event, slick, currentSlide) {
    if (slick.slideCount > 1) {
      const current = (currentSlide ? currentSlide : 0) + 1;
      if ($blogCurrentSlide.length !=0 ) {
        $blogCurrentSlide.text(current + '/' + slick.slideCount);
      }
    } else {
      $blogCurrentSlide.remove();
    }
  });
});
